import type { Tabell as TabellTyp } from '../types'

/** En jämförelsetabell ur avsnittets `tabeller[]`. Renderas sist i avsnittet
 *  (se Avsnitt.tsx) — källans schema knyter den bara till avsnittet som
 *  helhet, inte till en bestämd plats i brödtexten. */
export default function Tabell({ tabell }: { tabell: TabellTyp }) {
  return (
    <figure className="kapitel-tabell-figur">
      <h4>{tabell.rubrik}</h4>
      <div className="kapitel-tabell-rullning">
        <table className="kapitel-tabell">
          <thead>
            <tr>
              {tabell.kolumner.map((kolumn) => (
                <th key={kolumn}>{kolumn}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tabell.rader.map((rad, i) => (
              <tr key={i}>
                {rad.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {tabell.bildtext && <figcaption>{tabell.bildtext}</figcaption>}
    </figure>
  )
}
